import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { ZXingScannerModule, ZXingScannerComponent } from "@zxing/ngx-scanner";
import { BarcodeFormat } from '@zxing/library';
import { RouterModule } from '@angular/router';
import { QRScannerService } from "src/app/shared/services/qr-scanner.service";
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { ViewChild } from '@angular/core';

@Component({
    selector: 'app-qr-scanner',
    templateUrl: './qr-scanner.component.html',
    standalone: true,
    imports: [
        CommonModule,
        ZXingScannerModule,
        RouterModule,
        NgSelectModule,
        FormsModule
    ]
})
export class QRScannerComponent implements OnInit, OnDestroy {

    @ViewChild("scanner") scanner: ZXingScannerComponent;

    formatsEnabled: BarcodeFormat[] = [
        BarcodeFormat.QR_CODE,
    ];

    isLoading = true;

    private visibilityChangeHandler = () => {
        if (document.visibilityState === 'visible' && this.isMobileDevice()) {
            /*this.router.navigate(['/test-kit']);*/
            this.qrScannerService.noCameraAccess();
        }
    };

    constructor(private router: Router, private qrScannerService: QRScannerService) { }

    async ngOnInit() {
        document.addEventListener('visibilitychange', this.visibilityChangeHandler);
    }

    async ngAfterViewInit() {
        await this.qrScannerService.initialiseScanner(this.scanner);
        this.isLoading = false;
    }

    ngOnDestroy() {
        document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
        this.qrScannerService.closeScanner();
        this.qrScannerService.clear();
    }

    closeScanner() {
        if (this.qrScannerService.onClose) {
            this.qrScannerService.onClose();
        }
    }

    public get currentDevice() {
        return this.qrScannerService.currentDevice;
    }

    public get selectedDevice() {
        return this.qrScannerService.selectedDevice;
    }

    public set selectedDevice(value) {
        this.qrScannerService.selectedDevice = value;
    }

    public get normalisedDevices() {
        return this.qrScannerService.normalisedDevices;
    }

    public get isStreamInitializing() {
        return this.qrScannerService.isStreamInitializing;
    }

    public get torchEnabled() {
        return this.qrScannerService.torchEnabled;
    }

    public get torchAvailable() {
        return this.qrScannerService.torchAvailable;
    }

    onDeviceSelectChange(selectedValue: string) {
        if (this.qrScannerService.isStreamInitializing) {
            return;
        }
        this.qrScannerService.changeDevice(selectedValue);
    }

    onDeviceChange(device: MediaDeviceInfo) {
        this.qrScannerService.currentDevice = device;
        this.qrScannerService.selectedDevice = device.deviceId;
    }

    onTorchCompatible(isCompatible: boolean) {
        console.log("Torch compatible: ", isCompatible);
        this.qrScannerService.isTorchCompatible(isCompatible);
    }

    toggleTorch() {
        this.qrScannerService.toggleTorch();
    }

    get isMozillaBrowser() {
        return this.qrScannerService.isMozillaBrowser;
    }

    private isMobileDevice(): boolean {
        return /android|iphone|ipad/i
            .test(navigator.userAgent.toLowerCase());
    }
}




